/* i18n-disable-file: 路由 meta.title 直接使用中文 key，消费方需在设置 document.title 时调 i18n.t(meta.title) 进行翻译 */
const locals = require('@root/locals.json');
const { MODE: env } = require('@/config/env');

export default [
  {
    path: '/mng/sensitiveRecord',
    name: 'sensitiveRecord',
    component: () => import('@/pages/mng/safe/sensitiveRecord/App.vue'),
    children: [
      {
        path: '/',
        name: 'sensitiveRecordList',
        component: () => import('@/pages/mng/safe/sensitiveRecord/pages/list.vue'),
        meta: {
          title: '敏感操作日志',
          // 页面渲染之前需要加载的静态资源列表
          sourceList: {
            rhino: [
              locals[env].rhino.rhino_css_v2_stab,
              locals[env].rhino.rhino_js_v2_stab,
            ],
            TCaptcha: 'https://turing.captcha.qcloud.com/TCaptcha.js',
          },
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: '/tp/sensitiveWords',
    name: 'sensitiveWords',
    component: () => import('@/pages/mng/safe/sensitiveMonitor/list/App.vue'),
    meta: {
      title: '敏感词监控',
      dataUrl: '/v1/sensitive/pageData',
    },
  },
  {
    path: '/tp/sensitiveWords/page',
    name: 'sensitiveWordsEdit',
    component: () => import('@/pages/mng/safe/sensitiveMonitor/set/App.vue'),
    meta: {
      title: '敏感词监控编辑'
    },
  },
  {
    path: '/mng/account/loginSecurity',
    name: 'loginSecurity',
    component: () => import('@/pages/mng/safe/loginSafety/App.vue'),
    meta: {
      title: '登录安全',
      dataUrl: '/mng/account/loginSecurity/getLoginLevel',
    },
  },
];
